import React from 'react';
import SidebarNavigation, {ISidebarNavigation} from "components/Layout/SidebarNavigation/SidebarNavigation.Component";
import {connect} from "react-redux";
import {getCarRideDetailsByPositionInRides} from "Redux/Actions/HistoryActions";
import {RootState} from "Redux/Reducers/_RootReducer";

interface IDispatchProps extends Omit<ISidebarNavigation, 'totalItems'> {
}
interface IStateProps {
  totalItems: number
  rideListIndex: number
}

const HistoryRideNav: React.FC<IDispatchProps & IStateProps> = ({
  onNextClick,
  onPrevClick,
  totalItems,
  rideListIndex
}) => (
  <SidebarNavigation
    onNextClick={onNextClick}
    onPrevClick={onPrevClick}
    totalItems={totalItems}
    initialPage={rideListIndex + 1}
  />
)

const mapStateToProps = (state: RootState): IStateProps => ({
  totalItems: state.historyStore.carRidesHistorySummary.rides.length,
  rideListIndex: state.historyStore.rideListIndex
})

const mapDispatchToProps = (dispatch): IDispatchProps => ({
  // Cofam o jeden, by przypasować do indeksów z tablicy historyStore.carRidesHistorySummary.rides
  onNextClick: async (carRidePosition) => await dispatch(getCarRideDetailsByPositionInRides(carRidePosition - 1)),
  onPrevClick: async (carRidePosition) => await dispatch(getCarRideDetailsByPositionInRides(carRidePosition - 1))
})

export default connect(mapStateToProps, mapDispatchToProps)(HistoryRideNav)



// WEBPACK FOOTER //
// ./src/components/Map/CarDetails/Components/HistoryRideNav.Component.tsx